module.exports = __webpack_public_path__ + "media/fresh/arrow-47139b6d.svg";